const headline3 = (data) => {
  const node = data.node;
  const title = node.title;
  const serial = data.num;
  const color = data.color;
  const id = Math.random().toString(36).slice(-8);

  return {
    id: id,
    elements: [
      {
        type: "text",
        id: "IT4VEUPik2",
        width: 699.9710003428463,
        height: 94.28125,
        left: 240.00263197773486,
        top: 90.29964895962355,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style=""><strong><span style="font-size: 88.28125px;"><span style="font-family: Microsoft Yahei;"><span style="color: ${color};">${serial}</span></span></span></strong></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "Vri4gHOz1A",
        width: 657.8125,
        height: 81.25,
        left: 89.98129921259843,
        top: 226.6928313648294,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style=""><strong><span style="font-size: 47.65625px;"><span style="font-family: Microsoft Yahei;">${title}</span></span></strong></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "shape",
        id: "52hCkyXuWE",
        width: 28.142962598425196,
        height: 28.142962598425196,
        left: 248.84489829396324,
        top: 465.74729330708664,
        viewBox: [200, 200],
        path: "M 0 0 L 120 0 L 200 100 L 120 200 L 0 200 L 80 100 L 0 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "8wjQ0kLI-Y",
        width: 188.9,
        height: 33.65625,
        left: 89.98129921259843,
        top: 459.52181758530185,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style=""><span style="font-size: 25px;"><span style="font-family: Microsoft Yahei;"><span style="color:${color};text-align:right;">Chapter</span></span></span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "shape",
        id: "4UqsYCbKIn",
        width: 28.142962598425196,
        height: 28.142962598425196,
        left: 226.77345800524935,
        top: 464.74729330708664,
        viewBox: [200, 200],
        path: "M 0 0 L 120 0 L 200 100 L 120 200 L 0 200 L 80 100 L 0 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "2O3EIzcal3",
        width: 28.142962598425196,
        height: 28.142962598425196,
        left: 202.70193569553805,
        top: 464.74729330708664,
        viewBox: [200, 200],
        path: "M 0 0 L 120 0 L 200 100 L 120 200 L 0 200 L 80 100 L 0 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "line",
        id: "EQ_kyBC7cC",
        width: 0.75,
        left: 276.9877788713911,
        top: 479.8187335958005,
        start: [0, 0],
        end: [723.4261811023622, 0],
        style: "solid",
        color: `${color}`,
        points: ["", ""],
      },
      {
        type: "shape",
        id: "qQZcT6w7hm",
        width: 109.2756151461445,
        height: 74.80708299562002,
        left: 119.74445910123409,
        top: 143.77984297495817,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: "#ffffff",
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "6FsN85NLzk",
        width: 111.4064091286924,
        height: 111.40640912869237,
        left: 97.34011777604029,
        top: 91.77618158412191,
        viewBox: [170.02001312335958, 170.02001312335958],
        path: "M 25.843869868151817 0 L 144.17614325520776 0 Q 170.02001312335958 0 170.02001312335958 25.843869868151817 L 170.02001312335958 144.17614325520776 Q 170.02001312335958 170.02001312335958 144.17614325520776 170.02001312335958 L 25.843869868151817 170.02001312335958 Q 0 170.02001312335958 0 144.17614325520776 L 0 25.843869868151817 Q 0 0 25.843869868151817 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        pathFormula: "roundRect",
        keypoint: 0.15200486927030502,
        gradient: {
          type: "linear",
          rotate: 0,
          color: [`${color}97`, `${color}`],
        },
        shadow: { h: 1, v: 1, blur: 2, color: "#000" },
      },
      {
        type: "shape",
        id: "EtHTU4kmpJ",
        width: 70.38092012366116,
        height: 62.72204776773904,
        left: 115.29899749298096,
        top: 118.05284297169682,
        viewBox: [1024, 1024],
        path: "M852.65066667 405.84533333C800.54044445 268.40177778 667.76177778 170.66666667 512.22755555 170.66666667S223.91466667 268.288 171.80444445 405.73155555C74.29688889 431.33155555 2.27555555 520.07822222 2.27555555 625.77777778c0 125.72444445 101.83111111 227.55555555 227.44177778 227.55555555h564.56533334C919.89333333 853.33333333 1021.72444445 751.50222222 1021.72444445 625.77777778c0-105.472-71.79377778-194.21866667-169.07377778-219.93244445z",
        fill: "#ffffff",
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        special: true,
      },
    ],
    background: { type: "solid", color: "#ffffff" },
  };
};

export default headline3;
